import { Component } from '@angular/core';
import { AppConfigurationService } from '../../core/appConfiguration/app-configuration.service';
import { EnvTypeEnum } from '../../@admin/utils/constant';

@Component({
  selector: 'env-type',
  standalone: true,
  imports: [],
  templateUrl: './env-type.component.html',
  styleUrl: './env-type.component.scss'
})
export class EnvTypeComponent {

  EnvTypeEnum = EnvTypeEnum;
  constructor(public _appConfig: AppConfigurationService) {
    
  }
}
